import { oigBoardName } from '../../../../backend/constants';
export const defaultOccupationData = [
    {
        name: 'ACA - Certified Addiction Counselor I',
        status: 'active',
        description: '',
        disciplineId: '871',
        group: 'Medical',
        report: 'Physician Assistants',
        oNetSocCode: '22-1010',
        function: 'Mass Care, Emergency Assistance, Housing, and Human Services',
        calculateEcl: true,
        credentials: `Degree Information::ECL 4;Advanced Practice Nurse Specialty:DEA:ECL 2:ECL 4;Veterinarian Specialty::ECL 1;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4`,
    },
    {
        name: 'Advanced Emergency Medical Technician (AEMT)',
        status: 'active',
        description: '',
        disciplineId: '738',
        group: 'Medical',
        report: 'EMS Professionals',
        oNetSocCode: '',
        function: 'Public Health and Medical Services',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Degree Information::ECL 4;Experience Specialty::ECL 3;Professional Status::ECL 3;Hospital Affiliation:;Place of Practice::ECL 1;National Registry for Emergency Medical Technicians:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4`,
    },
    {
        name: 'Advanced Practice Registered Nurse (APRN)',
        status: 'active',
        description: '',
        disciplineId: '339',
        group: 'Medical',
        report: 'Nurse Practitioners',
        oNetSocCode: '',
        calculateEcl: false,
        credentials: `Degree Information::ECL 4;Professional License::ECL 1:ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Clinical Experience::ECL 2;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;American Board of Nursing Specialty Certification:;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2:ECL 4;Advanced Practice Nurse Specialty::ECL 1:ECL 2:ECL 3`,
    },
    {
        name: 'ARNP - Anesthetist',
        status: 'active',
        description: '',
        disciplineId: '607',
        group: 'Medical',
        oNetSocCode: '',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Clinical Experience::ECL 1:ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;American Board of Nursing Specialty Certification:;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2;Advanced Practice Nurse Specialty::ECL 1:ECL 2:ECL 3`,
    },
    {
        name: 'ARNP - Community Health',
        status: 'active',
        description: '',
        disciplineId: '608',
        group: 'Medical',
        oNetSocCode: '',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Clinical Experience::ECL 1:ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;American Board of Nursing Specialty Certification:;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2:ECL 4;Advanced Practice Nurse Specialty::ECL 1:ECL 2:ECL 3`,
    },
    {
        name: 'ARNP - Enterostomal Therapy',
        status: 'active',
        description: '',
        disciplineId: '609',
        group: 'Medical',
        oNetSocCode: '',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Clinical Experience::ECL 1:ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;American Board of Nursing Specialty Certification:;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2:ECL 4;Advanced Practice Nurse Specialty::ECL 1:ECL 2:ECL 3`,
    },
    {
        name: 'ARNP - Maternal Gynecological Neonatal',
        status: 'active',
        description: '',
        disciplineId: '610',
        group: 'Medical',
        oNetSocCode: '',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Clinical Experience::ECL 1:ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;American Board of Nursing Specialty Certification:;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2:ECL 4;Advanced Practice Nurse Specialty::ECL 1:ECL 2:ECL 3`,
    },
    {
        name: 'ARNP - Medical Surgical',
        status: 'active',
        description: '',
        disciplineId: '611',
        group: 'Medical',
        oNetSocCode: '',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Clinical Experience::ECL 1:ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;American Board of Nursing Specialty Certification:;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2:ECL 4;Advanced Practice Nurse Specialty::ECL 1:ECL 2:ECL 3`,
    },
    {
        name: 'ARNP - Midwife',
        status: 'active',
        description: '',
        disciplineId: '612',
        group: 'Medical',
        oNetSocCode: '',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Clinical Experience::ECL 1:ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;American Board of Nursing Specialty Certification:;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2:ECL 4;Advanced Practice Nurse Specialty::ECL 1:ECL 2:ECL 3`,
    },
    {
        name: 'ARNP - Neurosurgical',
        status: 'retired',
        description: '',
        disciplineId: '613',
        group: 'Medical',
        oNetSocCode: '',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Clinical Experience::ECL 1;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;American Board of Nursing Specialty Certification:;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2:ECL 4;Advanced Practice Nurse Specialty::ECL 1:ECL 2:ECL 3`,
    },
    {
        name: 'ARNP - Occupational Health',
        status: 'active',
        description: '',
        disciplineId: '614',
        group: 'Medical',
        oNetSocCode: '',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;American Board of Nursing Specialty Certification:;Professional Status:;Place of Practice::ECL 1:ECL 2:ECL 4;Advanced Practice Nurse Specialty::ECL 1:ECL 2:ECL 3`,
    },
    {
        name: 'Cardiovascular Technologist / Technician',
        status: 'active',
        description: '',
        disciplineId: '16',
        group: 'Medical',
        report: 'Other Public Health/Medical',
        oNetSocCode: '29-2031',
        function: 'Public Health and Medical Services',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Clinical Experience::ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2;Cardiovascular Technologist / Technician Specialty::ECL 1:ECL 2:ECL 3;ASCP Certification Status:`,
    },
    {
        name: 'Dentist',
        status: 'active',
        description: '',
        disciplineId: '816',
        group: 'Medical',
        report: 'Dentists',
        oNetSocCode: '29-1020',
        function: 'Public Health and Medical Services',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Clinical Experience::ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2:ECL 4;Dental Specialty:`,
    },
    {
        name: 'Emergency Medical Technician (EMT)',
        status: 'active',
        description: '',
        disciplineId: '737',
        group: 'Medical',
        report: 'EMS Professionals',
        oNetSocCode: '29-2040',
        function: 'Public Health and Medical Services',
        calculateEcl: true,
        credentials: `Professional License::ECL 2:ECL 3;Experience Specialty:;${oigBoardName}:OIG:ECL 2:ECL 3:ECL 4;Adverse Actions:;Professional Status:;National Registry for Emergency Medical Technicians:`,
    },
    {
        name: 'Licensed Practical Nurse',
        status: 'active',
        description: '',
        disciplineId: '11',
        group: 'Medical',
        report: 'Nurses',
        oNetSocCode: '29-2061',
        function: 'Public Health and Medical Services',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Clinical Experience::ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;American Board of Nursing Specialty Certification:;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2:ECL 4`,
    },
    {
        name: 'Marriage and Family Therapist',
        status: 'active',
        description: '',
        disciplineId: '1',
        group: 'Medical',
        report: 'Mental Health Professionals',
        oNetSocCode: '21-1013',
        function: 'Public Health and Medical Services',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Clinical Experience::ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;American Association for Marriage and Family Therapy Exam:;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2:ECL 4`,
    },
    {
        name: 'Medical and Clinical Laboratory Technicians',
        status: 'active',
        description: '',
        disciplineId: '17',
        group: 'Medical',
        oNetSocCode: '',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Clinical Experience::ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice:;Laboratory Technician Specialty::ECL 1:ECL 2:ECL 3;Laboratory Technologist Specialty:`,
    },
    {
        name: 'Medical and Clinical Laboratory Technologists',
        status: 'active',
        description: '',
        disciplineId: '18',
        group: 'Medical',
        oNetSocCode: '',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Clinical Experience:;Degree Information::ECL 4;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice:;Laboratory Technologist Specialty::ECL 1:ECL 2:ECL 3`,
    },
    {
        name: 'Medical Records and Health Information Technician',
        status: 'active',
        description: '',
        disciplineId: '765',
        group: 'Medical',
        oNetSocCode: '',
        calculateEcl: true,
        credentials: `Clinical Experience::ECL 2;Degree Information::ECL 4;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Hospital Affiliation::ECL 1;Medical Records and Health Information Technologist Specialty::ECL 1:ECL 2:ECL 3`,
    },
    {
        name: 'Mental Health Counselor (MHC)',
        status: 'active',
        description: '',
        disciplineId: '4',
        group: 'Medical',
        report: 'Mental Health Professionals',
        oNetSocCode: '21-1014',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Clinical Experience::ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2:ECL 4;MHC Specialty:`,
    },
    {
        name: 'Naturopathic Physician',
        status: 'active',
        description: '',
        disciplineId: '577',
        group: 'Medical',
        oNetSocCode: '',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Clinical Experience::ECL 2;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Degree Information::ECL 4;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice:`,
    },
    {
        name: 'Osteopathic Physician and Surgeon',
        status: 'active',
        description: '',
        disciplineId: '632',
        group: 'Medical',
        oNetSocCode: '',
        calculateEcl: false,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;American Board of Medical Specialties Certification::ECL 1:ECL 2;American Osteopathic Association Certification::ECL 1:ECL 2;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Clinical Experience::ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2`,
    },
    {
        name: 'Pharmacist',
        status: 'active',
        description: '',
        disciplineId: '12',
        group: 'Medical',
        report: 'Pharmacists',
        oNetSocCode: '29-1051',
        function: 'Public Health and Medical Services',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA;Clinical Experience::ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Injection Administration:;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2:ECL 4;Pharmacy Specialty:;Board of Pharmaceutical Specialty:`,
    },
    {
        name: 'Physician and Surgeon',
        status: 'active',
        description: '',
        disciplineId: '632',
        group: 'Medical',
        report: 'Physicians',
        oNetSocCode: '29-1060',
        function: 'Public Health and Medical Services',
        calculateEcl: true,
        credentials: `Physician and Surgeon Professional License::ECL 1:ECL 2:ECL 3;American Board of Medical Specialties Certification::ECL 1:ECL 2;American Osteopathic Association Certification::ECL 1:ECL 2;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Clinical Experience::ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;International Medical Graduate:;Medical Residency Information:;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2;Board Certification:;FSMB Clearance Status:;ASCP Certification Status:`,
    },
    {
        name: 'Physician Assistant',
        status: 'active',
        description: '',
        disciplineId: '13',
        group: 'Medical',
        report: 'Physician Assistants',
        oNetSocCode: '29-1070',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Clinical Experience::ECL 2;Degree Information::ECL 4;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2;National Commission on Certification of Physician Assistants::ECL 1:ECL 2:ECL 3;Physician Assistant Specialty Experience:`,
    },
    {
        name: 'Psychologist',
        status: 'active',
        description: '',
        disciplineId: '6',
        group: 'Medical',
        report: 'Mental Health Professionals',
        oNetSocCode: '19-3039',
        function: 'Public Health and Medical Services',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA:ECL 1:ECL 2;Clinical Experience:;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Adverse Actions:;American Board of Professional Psychology Certification:;Degree Information::ECL 4;Professional Status:`,
    },
    {
        name: 'Radiologic Technologist',
        status: 'active',
        description: '',
        disciplineId: '29',
        group: 'Medical',
        report: 'Other Public Health/Medical',
        oNetSocCode: '',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Clinical Experience::ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice:;Radiologic Technologist/Technician Specialty::ECL 1:ECL 2:ECL 3`,
    },
    {
        name: 'Registered Nurse (RN)',
        status: 'active',
        description: '',
        disciplineId: '7',
        group: 'Medical',
        report: 'Nurses',
        oNetSocCode: '29-1111',
        function: 'Public Health and Medical Services',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Clinical Experience:;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;American Board of Nursing Specialty Certification:;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2`,
    },
    {
        name: 'Respiratory Therapist',
        status: 'active',
        description: '',
        disciplineId: '15',
        group: 'Medical',
        report: 'Respiratory Therapists',
        oNetSocCode: '29-1126',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Clinical Experience:;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice:`,
    },
    {
        name: 'Social Worker, Clinical (CSW)',
        status: 'active',
        description: '',
        disciplineId: '358',
        group: 'Medical',
        report: 'Mental Health Professionals',
        oNetSocCode: '',
        function: 'Public Health and Medical Services',
        calculateEcl: true,
        credentials: `Professional License::ECL 1:ECL 2:ECL 3;Clinical Experience::ECL 2;Degree Information::ECL 4;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice:`,
    },
    {
        name: 'Sonographer, Diagnostic',
        status: 'active',
        description: '',
        disciplineId: '37',
        group: 'Medical',
        report: 'Other Public Health/Medical',
        oNetSocCode: '29-2032',
        function: 'Public Health and Medical Services',
        calculateEcl: true,
        credentials: `Professional License:;Clinical Experience::ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Professional Status:;Hospital Affiliation::ECL 1;Place of Practice::ECL 1:ECL 2:ECL 4;Diagnostic Medical Sonographer Certification::ECL 1:ECL 2:ECL 3`,
    },
    {
        name: 'Veterinarian',
        status: 'active',
        description: '',
        disciplineId: '14',
        group: 'Medical',
        report: 'Veterinarians',
        oNetSocCode: '29-1131',
        function: 'Agriculture and Natural Resources',
        calculateEcl: true,
        credentials: `Professional License::ECL 2:ECL 3;Drug Enforcement Agency Registration:DEA:ECL 2;Clinical Experience::ECL 2;Degree Information::ECL 4;Experience Specialty:;${oigBoardName}:OIG:ECL 1:ECL 2:ECL 3:ECL 4;Professional Status:;Place of Practice::ECL 2:ECL 4;Veterinarian Specialty:`,
    },
];
